const paths = {
  redirect: {
    application: '/redirect/application',
  },
  auth: {
    _: '/auth',
    redirectToKeyCloak: `/api/v1/auth/merchant/redirect/marketplace-signup`,
    merchantAuthCallback: '/merchantAuthCallback',
    merchantInviteAuthCallback: '/merchantInviteAuthCallback',
    redirectAgentToKeyCloak: `/api/v1/auth/merchant/redirect/agent-signup`,
    redirectSalesToKeyCloak: `/api/v1/auth/merchant/redirect/sales-signup`,
    agentAuthCallback: '/agentAuthCallback',
    salesAuthCallback: '/salesAuthCallback',
  },
  home: {
    _: '/',
  },
  companyType: {
    _: '/companyType',
  },
  letsStart: {
    _: '/letsStart',
  },
  cardHolder: {
    _: '/cardHolder',
    details: '/cardHolder/details',
    consent: '/cardHolder/consent',
    completion: '/cardHolder/completion',
    softRejection: '/cardHolder/cardholder-softRejection',
  },
  getInTouch: {
    _: '/getInTouch',
  },
  wizard: {
    _: '/wizard',
    services: '/wizard/services',
    application: '/wizard/application',
    signContract: '/wizard/signContract',
    payment: '/wizard/payment',
    completion: '/stageResult',
  },
  stageResult: {
    _: '/stageResult',
    waitingForScreening: '/stageResult/waitingForScreening',
    error: '/stageResult/error',
    screeningError: '/stageResult/screeningError',
    screeningReject: '/stageResult/screeningReject',
    salesforceSoftDecline: '/stageResult/salesforceSoftDecline',
    salesforceHardDecline: '/stageResult/salesforceHardDecline',
    submit: '/stageResult/submit',
    salesforceError: '/stageResult/salesforceError',
    salesforceTechnicalError: '/stageResult/salesforceTechnicalError',
    completed: '/stageResult/completed',
    successfulOnboarding: '/stageResult/successfulOnboarding',
    unknownStage: '/stageResult/unknownStage',
    allProductsOnboarded: '/stageResult/allProductsOnboarded',
  },
  agent: {
    _: '/agent',
    leads: '/agent/leads',
    applications: '/agent/applications',
    map: '/agent/map',
  },
  sales: {
    _: '/sales',
  },
};

export default paths;
